class ProductSizeVariants extends HTMLElement {
constructor() {
  super();

  const radios = this.querySelectorAll("input[type='radio']");
  if (radios.length) {
    radios.forEach((radio) => {
      radio.addEventListener("input", () => {
        const handle = radio.value;
        if (handle) {
          const addButton = document.querySelector(".js-product-add");
          if (addButton) {
            addButton.classList.add("loading");
          }
          this.changeVariant(handle);
        }
      });

      // Fix: handle Enter/Space keydown on the associated label
      const label = this.querySelector(`label[for="${radio.id}"]`);
      if (label) {
        label.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            label.click(); // triggers the radio check + input event
          }
        });
      }
    });
  }
}

  changeVariant(handle) {
    const currentUrl = new URL(window.location.href);
    const baseUrl = `${currentUrl.origin}${currentUrl.pathname.split('/products/')[0]}`;
    location.href = `${baseUrl}/products/${handle}`;
  }
}

customElements.define("size-variants", ProductSizeVariants);
